import { Box, ChakraProvider, Flex, theme } from '@chakra-ui/react'
import { createRef, useContext, useEffect } from 'react'
import { Context3D } from './utils/3d-context'
import {
  customLoadingUIText,
  runRenderLoop,
  setupEngine,
} from './utils/commonLib/engine'
import {
  addDOMEvents,
  loadPathway,
  setProducts,
  setupFpsCamera,
  setupLight,
  setupScene,
} from './utils/commonLib/vr'
import { setDefaultEnvironment, setUpEnvironment } from './utils/environment'
import { loadRoom } from './utils/commonLib/vr'
import { vrProducts } from '../_mocks_/vr-products'
import { AppContext } from './libs/context'
import { toggleInspector } from './utils/commonLib/scene'

export default function VRStudio() {
  const canvasRef = createRef<HTMLCanvasElement>()
  const fpsRef = createRef<HTMLDivElement>()

  const context = useContext(AppContext)

  const { model, shop, ready, setModel, setReady } = context

  useEffect(() => {
    return () => {
      Context3D.get().engine?.dispose() // prevent hotload expensive duplicate added engine
      // window.location.reload()
    }
  }, [])

  useEffect(() => {
    if (shop) {
      initialize()
    }
  }, [shop])

  const initialize = async () => {
    if (!canvasRef.current) return
    if (fpsRef.current) Context3D.set({ fpsIndicator: fpsRef.current })

    setupEngine({}, canvasRef.current)
    setupScene()
    // setupCamera({ speed: 1 })
    setupFpsCamera()

    customLoadingUIText('Loading model')
    setDefaultEnvironment()
    await loadRoom()
    await loadPathway()

    await setProducts(vrProducts, context)

    // setupFloor()
    setupLight()

    Context3D.get().engine?.hideLoadingUI()
    customLoadingUIText('')

    // const skybox = skyBoxes.find(skybox => skybox.id === 'New York Night')

    // if (skybox) {
    //   setUpEnvironment(skybox)
    // }
    setUpEnvironment(
      {
        id: '',
        type: '3d',
        previewUrl: '',
        // path: '/assets/vignaioli_night_4k.hdr',
        path: '/assets/dresden_square_4k.hdr',
        name: '',
      },
      Context3D.get(),
      false
    )

    runRenderLoop()

    addDOMEvents(vrProducts, context)

    // toggleInspector()
  }

  return (
    <ChakraProvider theme={theme}>
      <Flex color="white" id="main-container">
        <Box flex="1" id="babylon-container">
          <canvas ref={canvasRef} id="babylon-canvas-vr" />
        </Box>
      </Flex>

      {/* show fps indicator */}
      <div id="fps_indicator" ref={fpsRef}></div>
    </ChakraProvider>
  )
}
